import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children, requireEmailConfirmed = false }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        // User is not authenticated, redirect to auth page
        navigate('/auth');
        return;
      }

      // Optionally enforce email confirmation for sensitive routes (e.g., checkout, orders)
      if (requireEmailConfirmed && !user.email_confirmed_at) {
        navigate('/home', { state: { requireEmailConfirm: true } });
        return;
      }
    }
  }, [user, loading, navigate, requireEmailConfirmed]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <div
          style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #3498db',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            marginBottom: '1rem',
          }}
        ></div>
        <p style={{ color: 'white', fontSize: '1.1rem' }}>Loading...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  // If user is not authenticated or (email not confirmed when required), don't render children
  // (redirect will happen in useEffect)
  if (!user || (requireEmailConfirmed && !user.email_confirmed_at)) {
    return null;
  }

  // User is authenticated and email is confirmed, render protected content
  return children;
}

export default ProtectedRoute;
